import { Modal, Button } from "react-bootstrap";

const PrivacyPolicyModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Flavchap.com - Privacy Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Last Updated: </strong>{process.env.REACT_APP_PRIVACY_UPDATE_DATE}</p>
        <h5>Hello User!</h5>
        <p>
          Welcome to <strong>flavchap.com</strong> (“flavchap”, “we”, “us”, or “our”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you visit or use our website, mobile services, or make purchases through our platform. By using our website, you agree to the terms of this policy.
        </p>

        <h6>1. Information We Collect</h6>
        <p>
          We collect personal and non-personal information to provide and improve our products and services.
          <ul>
            <li>
              <strong>Personal Information:</strong> Includes your name, phone number,
              email address, shipping/billing address, and payment details (processed
              securely through our payment partners; we do not store full card
              details).
            </li>
            <li>
              <strong>Automatically Collected Information:</strong> Includes your IP
              address, browser type, device details, access times, and browsing
              behavior on our site through cookies and analytics tools.
            </li>
          </ul>
        </p>

        <h6>2. How We Use Your Information</h6>
        <p>
          We may use your information for:
          <ul>
            <li>Processing and fulfilling your orders, payments, and deliveries.</li>
            <li>Communicating order updates, confirmations, and support messages.</li>
            <li>Improving our website, product offerings, and customer experience.</li>
            <li>Sending promotional offers or newsletters (only if you opt in).</li>
            <li>Detecting, preventing, or addressing fraud and security issues.</li>
            <li>Complying with legal or regulatory obligations.</li>
          </ul>
        </p>

        <h6>3. How We Share Your Information</h6>
        <p>
          We do not sell or rent your personal data. We only share it with trusted
          partners when necessary:
          <ul>
            <li>
              <strong>Delivery Partners</strong> – to ensure timely and accurate delivery.
            </li>
            <li>
              <strong>Payment Gateways</strong> – for secure transaction processing.
            </li>
            <li>
              <strong>Service Providers</strong> – for hosting, analytics, or communication tools.
            </li>
            <li>
              <strong>Legal Authorities</strong> – when required by law or regulation.
            </li>
          </ul>
        </p>

        <h6>4. Data Retention</h6>
        <p>
          We retain your personal data only as long as necessary to fulfill your orders, provide services, or comply with legal obligations. After this period, data is securely deleted or anonymized.
        </p>

        <h6>5. Data Security</h6>
        <p>
          We use industry-standard security measures, including HTTPS encryption and secure payment gateways, to protect your data. However, no online platform can guarantee complete security, and you share information at your own risk.
        </p>

        <h6>6. Your Rights</h6>
        <p>
          You may have the right to:
          <ul>
            <li>Access or correct your personal information.</li>
            <li>Request deletion of your personal data.</li>
            <li>Withdraw consent for promotional communications.</li>
          </ul>
          To exercise these rights, contact us at <strong>info@ncgglobalenterprises.com</strong>.
        </p>

        <h6>7. Cookies and Tracking Technologies</h6>
        <p>
          We use cookies to enhance your browsing experience, analyze traffic, and remember preferences. You can disable cookies in your browser settings, though some site features may not function properly as a result.
        </p>

        <h6>8. Communications and Marketing</h6>
        <p>
          You may receive transactional messages (order updates, confirmations) and promotional offers (if opted in). You can unsubscribe from promotional messages at any time.
        </p>

        <h6>9. Third-Party Links</h6>
        <p>
          Our website may contain links to third-party sites. We are not responsible for their content or privacy practices. Please review their policies before providing personal data.
        </p>

        <h6>10. Children’s Privacy</h6>
        <p>
          Our services are intended for users aged 18 and above. We do not knowingly collect information from minors. If a child has shared data with us, please contact us for prompt deletion.
        </p>

        <h6>11. Changes to This Privacy Policy</h6>
        <p>
          We may update this Privacy Policy from time to time. Any updates will be posted on this page with a revised “Last Updated” date. Continued use of our services implies acceptance of any changes.
        </p>

        <h6>12. Contact Us</h6>
        <p>
          For questions or concerns about this Privacy Policy, please reach out to us:
          <br />
          📧 <strong>info@ncgglobalenterprises.com</strong>
          <br />
          🌐 <strong>www.flavchap.com</strong>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PrivacyPolicyModal;